import {IComment} from '../model/commentModel';

export const sortCommentsByTime = (comments: IComment[]): IComment[] => {
   const commentSort = (a: IComment, b: IComment): number => a.time - b.time || Date.parse(a.createDate) - Date.parse(b.createDate);

   return comments.sort(commentSort);
};